module.exports = __webpack_public_path__ + "static/media/download.d48cff11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/download.svg
// module id = 626
// module chunks = 0